<template>
  <div>
    <!-- modal dialogs -->
	<ChangeFieldSyncName></ChangeFieldSyncName>
    <b-modal id="modal-add-schema" title="Add Schema" @hide="refreshList" ok-only>
      <file-upload></file-upload>
    </b-modal>
    <b-modal id="modal-update-schema" size="xl" title="Schema Update" @hide="refreshList" ok-only>
      <schema-update />
    </b-modal>
    <b-modal id="modal-import-data" size="xl" title="Data Import" @hide="refreshList" ok-only>
      <data-import :schema="selectedSchema"></data-import>
    </b-modal>
    <b-modal id="modal-export-data" title="Data Export" @hide="refreshList" ok-only>
      <data-export :schema="selectedSchema"></data-export>
    </b-modal>
    <b-modal id="modal-admin-export-data" title="Admin Data Export" @hide="refreshList" ok-only>
      <data-admin-export :schema="selectedSchema"></data-admin-export>
    </b-modal>
    <b-modal id="modal-delete-schema" title="Delete Schema" @hide="refreshList" @ok="deleteSchema(selectedSchema)">
      <div>Are you sure you want to delete the schema and all related data?</div>
    </b-modal>
    <b-modal id="modal-delete-data" title="Delete Data" @hide="refreshList" @ok="deleteData(selectedSchema)">
      <div>Are you sure you want to delete all data created by you?</div>
    </b-modal>
    <b-modal id="modal-delete-all-data" title="Delete All Data" @hide="refreshList" @ok="deleteAllData(selectedSchema)">
      <div>Are you sure you want to delete all data?</div>
    </b-modal>
    <b-modal id="sync-data-with-cloud" :title="'Checking data on DMIx'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc hide-header-close>
      <div>
        <table style="height: 100px;">
          <tbody>
          <tr>
            <td>
              <span v-if="!errorHappened">{{syncMessage}}</span><b-spinner  v-if="!errorHappened && !syncDone" style="margin-left: 10px" label="Loading..."></b-spinner>
              <span v-if="errorHappened" style="color: darkred">{{errorMessage}}</span>
            </td>
          </tr>
          <tr>
            <td><b-button v-if="syncDone" @click="$bvModal.hide('sync-data-with-cloud')" title="Close">Close</b-button></td>
          </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <!-- end of modals -->

    <div>
      <div class="text-left">
        <b-button size="sm" class="m-2" @click="showAddSchemaModal" v-if="isAdmin">Add Schema</b-button>
        <b-button size="sm" class="m-2" @click="showUpdateSchemaModal" v-if="isAdmin">Update Schema</b-button>
      </div>
      <div class="text-right" style="padding-right: 10px">
        Version {{appVersion}}
      </div>
      <b-table hover :items="schemas" :fields="fields" striped responsive="sm" class="m-2"
      >

        <template v-slot:cell(actions)="row">
          <b-button-group vertical>
            <b-button size="sm" @click="gotoDataEditor(row)" class="mr-2">
              View/Edit Data
            </b-button>
            <b-button size="sm" @click="gotoExcelTemplate(row)" class="mr-2">
              Download Template
            </b-button>
            <b-button size="sm" class="mr-2" @click="showImportDataModal(row)">Import Data</b-button>

            <b-button size="sm" @click="showExportDataModal(row)" class="mr-2">
              Export User Data
            </b-button>
            <b-button v-if="isAdmin" size="sm" @click="showAdminExportDataModal(row)" class="mr-2">
              Export Admin Data
            </b-button>
            <b-button size="sm" class="mr-2" @click="showDeleteDataModal(row)">Delete Data</b-button>
            <b-button v-if="isAdmin" size="sm" class="mr-2" @click="showDeleteAllDataModal(row)">Delete All Data</b-button>
            <b-button v-if="isAdmin" size="sm" @click="downloadSchema(row)" class="mr-2">
              Download Schema File
            </b-button>
            <b-button v-if="isAdmin" size="sm" class="mr-2" @click="showDeleteSchemaModal(row)">Delete Schema</b-button>
            <b-button v-if="isAdmin" size="sm" @click="syncWithCloud(row)" class="mr-2">
              Check Status with DMIx
            </b-button>
			<b-button v-if="isAdmin" size="sm" @click="defineSyncTag(row)" class="mr-2">
              Define sync field name
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {BackendApiService} from '../services/BackendApiService'
import FileUpload from './FileUpload'
import DataImport from './DataImport'
import SchemaUpdate from './SchemaUpdate'
import DataExport from './DataExport'
import DataAdminExport from './DataAdminExport'
import ChangeFieldSyncName from './ChangeFieldSyncName' 

export default {
  data () {
    return {
      fields: [
        {key: 'warn', label: ''},
        {key: 'schema.title', label: 'Title'},
        {key: 'schema.customerId', label: 'ID'},
        {key: 'schema.version', label: 'Version'},
        {key: 'itemCount', label: '# of Items'},
        {key: 'propertyCount', label: '# of Props'},
        {key: 'refCount', label: '# of Refs'},
        {key: 'actions', label: 'Actions'}],
      schemas: [],
      selectedSchema: {},
      appVersion: '',
      errorHappened: false,
      errorMessage: '',
      syncDone: false,
      syncMessage: '',
      counter: 0,
      total: 0,
      timer: null,
	  syncFieldname: ''
    }
  },
  components: {
    FileUpload,
    SchemaUpdate,
    DataImport,
    DataExport,
    DataAdminExport,
	ChangeFieldSyncName
  },
  computed: {
    isAdmin () {
      return this.$store.getters.isAdmin
    }
  },
  methods: {
    gotoDataEditor (row) {
      this.selectedSchema = row.item.schema
      // Show the modal
      this.$router.push({ name: 'dataEditor', params: { schemaId: this.selectedSchema.id } })
    },
    gotoExcelTemplate (row) {
      let href = window.location.origin + '/api/excelTemplate/' + row.item.schema.id + '/' + this.$store.getters.username
      window.location.href = href
    },
    showAddSchemaModal () {
      // Show the modal
      this.$bvModal.show('modal-add-schema')
    },
    showUpdateSchemaModal () {
      // Show the modal
      this.$bvModal.show('modal-update-schema')
    },
    showImportDataModal (row) {
      this.selectedSchema = row.item.schema
      // Show the modal
      this.$bvModal.show('modal-import-data')
    },
    showExportDataModal (row) {
      this.selectedSchema = row.item.schema
      // Show the modal
      this.$bvModal.show('modal-export-data')
    },
    showAdminExportDataModal (row) {
      this.selectedSchema = row.item.schema
      // Show the modal
      this.$bvModal.show('modal-admin-export-data')
    },
    showDeleteSchemaModal (row) {
      this.selectedSchema = row.item.schema
      // Show the modal
      this.$bvModal.show('modal-delete-schema')
    },
    showDeleteDataModal (row) {
      this.selectedSchema = row.item.schema
      // Show the modal
      this.$bvModal.show('modal-delete-data')
    },
    showDeleteAllDataModal (row) {
      this.selectedSchema = row.item.schema	  
      // Show the modal
      this.$bvModal.show('modal-delete-all-data')
    },
    refreshList () {
      BackendApiService.getSchemas().then(response => {
        console.log('refreshing data')
        this.schemas = response.data
      })
    },
    deleteSchema (schema) {
      BackendApiService.deleteSchema(schema.id).then(response => {
        this.refreshList()
      })
    },
    downloadSchema (row) {
      window.location.href = window.location.origin + '/api/schemaDownload/' + row.item.schema.id
    },
    deleteData (schema) {
      BackendApiService.deleteData(schema.id).then(response => {
        this.refreshList()
      })
    },
    deleteAllData (schema) {
      BackendApiService.deleteAdminData(schema.id).then(response => {
        this.refreshList()
      })
    },
    syncWithCloud (row) {
      this.selectedSchema = row.item.schema
      // Show the modal
      this.errorHappened = false
      this.syncDone = false
      this.errorMessage = ''
      this.syncMessage = 'Checking data on DMIx, please wait.'
      this.counter = 0
      this.total = 0
      this.$bvModal.show('sync-data-with-cloud')

      BackendApiService.startDmixSync(this.selectedSchema.id).then(response => {
        // clearInterval(this.timer)
        this.syncDone = true
        this.syncMessage = response.data
      }).catch((error) => {
        this.errorMessage = error
        this.errorHappened = true
        this.syncDone = true
      })
    },	
	defineSyncTag(row) {
		this.selectedSchema = row.item.schema		
		this.$store.state.selectedSchema = this.selectedSchema;
		this.$bvModal.show('modal-change-sync-name')
	},
	closeSyncWithCloud () {
		this.$bvModal.hide('sync-data-with-cloud')
	}
  },  
  mounted () {
    BackendApiService.getSchemas().then(response => {
      this.schemas = response.data
    })

    BackendApiService.readVersion().then(response => {
      this.appVersion = response.data
    })
  }
  // beforeDestroy () {
  //  clearInterval(this.timer)
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/SchemaList.vue